<app-payment-panel-stripe-generic
  type="STRIPE_APPLE_PAY"
  [isPayButtonVisible]="false"
></app-payment-panel-stripe-generic>
